var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Multivariate Dependencies
import { css } from 'styled-components';
// Types
import { ContentStylePropertiesByColor } from '../types/ContentStylePropertiesByColor';
export var getColorByContentColor = function (contentColor, theme) {
    if (contentColor === void 0) { contentColor = 'primary'; }
    var color = ContentStylePropertiesByColor[contentColor](theme).color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), color);
};
var templateObject_1;
//# sourceMappingURL=getColorByContentColor.js.map